import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=46096212&scoped=true&"
import script from "./PortalFooter.vue?vue&type=script&lang=js&"
export * from "./PortalFooter.vue?vue&type=script&lang=js&"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&id=46096212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46096212",
  null
  
)

export default component.exports